module.exports = __webpack_public_path__ + "img/ke.d35eb79a.svg";